import React, { useState, useContext, useEffect } from 'react';
import { UserSettingsContext } from "../../context/UserSettingsContext";
import { Flame, ChartCandlestick, ChartColumn, Coins, Star, Gift, Calculator } from 'lucide-react';

const SelectColumnBox = ({ setAccount, searchTerm }) => {
    const [showSubColumns, setShowSubColumns] = useState(false);
    const [selectedColumn, setSelectedColumn] = useState(null);
    const { selectableAccounts } = useContext(UserSettingsContext);
    const [filteredAccounts, setFilteredAccounts] = useState([]);
    const [categories, setCategories] = useState([])
    
    useEffect(() => {
        if (selectableAccounts) {
            const categories = Array.from(
            new Map(
                selectableAccounts.map(item => [JSON.stringify(item.category_1), item.category_1])
            ).values()
            )
            setCategories(categories)
        }
    }, [selectableAccounts])

    const getIcon = (category) => {
        switch (category) {
            case 'often_used':
                return <Star className='mr-2' />;
            case 'market':
                return <ChartCandlestick className='mr-2' />;
            case 'pl':
                return <ChartColumn className='mr-2' />;
            case 'bs':
                return <Coins className='mr-2' />;
            case 'cf':
                return <Flame className='mr-2' />;
            case 'indicator':
                return <Calculator className='mr-2' />;
            case 'dividend':
                return <Gift className='mr-2' />;
            default:
                return <Flame className='mr-2' />;
        }
    };

    const showSubColumnBox = (columnName, explanation) => {
        setShowSubColumns(true);
        setSelectedColumn({ columnName, explanation });
    };

    useEffect(() => {
        if (selectableAccounts) {
            const filteredAccounts = selectableAccounts.filter((account) => account.category_1.category !== 'often_used')
                .filter(account =>
                account.col_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                account.category_1.category_name.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredAccounts(filteredAccounts)
        }
    }, [searchTerm])
    
    const SubColumnBox = ({ column }) => {
        if (!column) return <></>;
        return (
            <div className="column-selections">
                <div className="category">{column.explanation}</div>
                <ul>
                    {selectableAccounts
                        .filter((account) => account.category_1.category === column.columnName)
                        .map((account) => (
                            <li key={account.col} className="h-9" onClick={() => setAccount(account)}>
                                <span className="pt-1">{account.col_name}</span>
                            </li>
                        ))}
                </ul>
            </div>
        );
    };

    return (
        <div className="selection-container py-0 z-[8000]">
            {searchTerm ?
                <div>
                    <ul>
                        {filteredAccounts.map((account) => (
                            <li key={account.col}
                                className="flex items-center h-8 my-1"
                                onClick={() => setAccount(account)}
                            >
                                {getIcon(account.category_1.category)} <span className='ml-1'>{account.col_name}</span>
                            </li>
                        ))}
                    </ul>
                </div>
                :
                <div className="categories">
                    <div className="category">カテゴリ</div>
                    <ul>
                        {categories.map((category) => (
                            <li
                                key={category.category}
                                onClick={() => showSubColumnBox(category.category, category.category_name)}
                                className="flex items-center h-8"
                            >
                                {getIcon(category.category)}
                                <div className="ml-2 pt-1 flex items-center">{category.category_name}</div>
                            </li>
                        ))}
                    </ul>
                </div>
            }
            {!searchTerm && showSubColumns && (
                <SubColumnBox column={selectedColumn} />
            )}
        </div>
    );
};

export default SelectColumnBox;
